/**
 * Created by coolguy on 2017/8/13.
 */
import React from 'react';
import {Table,Button,Modal, Input, Space, Icon} from 'antd';
import {connect} from 'react-redux';
import {getPhotoSrc} from '../../util/image';
import {unique} from '../../util/index';

const Search = Input.Search;

class ProductListForAdd extends React.Component {

    constructor(props) {
        super();
        this.state = {
            selectedRowKeys: props.data || [],  // Check here to configure the default column
            filteredInfo:null,
            filteredSearch:""
        };
    }

    componentWillReceiveProps(nextProps) {
        if(typeof nextProps.data != 'undefined') {
            this.setState({
                selectedRowKeys:nextProps.data
            });
        }
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    }
    selectProducts = ()=>{
        //关闭当前窗口，将值传递个上一个页面
        this.props.onChange && this.props.onChange(this.state.selectedRowKeys);
    }
    hide = ()=>{
        this.props.hide();
    }

    handleChange = (pagination, filters, sorter) => {
      this.setState({
        filteredInfo: filters
      });
    }

    filter = (list)=>{
      if(this.state.filteredSearch) {
        return list.filter(it=>{
          return it && it.name.indexOf(this.state.filteredSearch) > -1;
        });
      }
      return list;
    }

    doSearch = (e)=>{
      this.setState({
        filteredSearch:e
      })
    }

    render() {
        const {selectedRowKeys, filteredInfo = {}} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const columns = [{
            title:"分类",
            dataIndex:"category",
            filters:this.props.productList && this.props.productList.length ? unique(this.props.productList.map(it=>{
              if(it.category) {
                return {
                  text:it.category,
                  value:it.category
                }
              }
              return null
            }).filter(Boolean), (a, b)=>{
              return a.value == b.value;
            }) : [],
            filteredValue: filteredInfo ? filteredInfo.category : null,
            filterMultiple:true,
            onFilter: (value, record) => {
              if(!value || !value.length) {
                return true;
              }

              if(record && record.category) {
                return record.category.includes(value);
              }
              return false;
            }
        },{
            title: "名称",
            dataIndex: "name",
        },{
            title:"价格",
            dataIndex:"price",
            render:(price)=>{
                return (price/100).toFixed(2)
            }
        }];

        return (
            <Modal title="选择产品"
                   visible={this.props.visible}
                   onOk={this.selectProducts}
                   onCancel={this.hide}
                   okText="确认"
            >
                <div style={{overflowY:'scroll', height:380}}>
                    <Search placeholder="请输入产品名称" style={{marginBottom:20, width:200}} onSearch={this.doSearch} />
                    <Table
                        columns={columns}
                        dataSource={this.filter(this.props.productList)}
                        pagination={false}
                        rowSelection={rowSelection}
                        rowKey="id"
                        onChange={this.handleChange}
                    />
                </div>
            </Modal>
        )
    }
}

export default connect((state) => ({
    productList: state.productList
}))(ProductListForAdd);



// WEBPACK FOOTER //
// ./src/components/Select/ProductListForAdd.js